// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  LocalizableString,
} from "./types";


export default __t.row({
  dtmi: __t.string().primaryKey(),
  get displayName() {
    return LocalizableString.name("display_name");
  },
  context: __t.string(),
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
